export const MIN_OPTION_HEIGHT = 32;
export const MIN_OPTION_VISIBLE = 5;
export const ACCORDION_PADDING = 8;
